import React from "react"
import CardLine from "./CardLine";
import CardHeader from "./CardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faPlane, faAngleDoubleLeft  } from "@fortawesome/free-solid-svg-icons"; 


class Card extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            'open': false,
        }

      
    }
    

    handleClickGoToDestination = (event, click_location) => {
        this.props.GoToDestination(event, this.props.city_id, this.props.city_uid, this.props.city_name, click_location);
    }

    handleToggleDealDetails = (event) => {
        this.setState(prevState=>({
            'open': !prevState.open
        }))
    }

    render() {

        const item = this.props?.data;
        let more = '';
            
        if (this.props?.type!='days')
            more = (
                <div style={{lineHeight:'2.5rem', display:'flex', justifyContent:'center', alignItems:'center', background:'#1e5881db', fontWeight: 700, color:'#fff', cursor:'pointer', borderBottomLeftRadius:'5px', borderBottomRightRadius:'5px'}} className={'showMore'} onClick={e=> {this.handleClickGoToDestination(e, 'more')}}>
                        <div className='caption'>עוד דילים ל{this.props?.city_name} </div>
                        <div className='icon' style={{margin:'0 .5em 0 0'}}>
                            <FontAwesomeIcon icon={faAngleDoubleLeft}  />
                        </div>
                    </div>
            );


        let html = (
            <div key={`card_${this.props?.index}`} className={'dealcard'} >
                <CardHeader GoToDestination={this.handleClickGoToDestination} ToggleDealDetails={this.handleToggleDealDetails} type={this.props?.type} ShowCardLine={this.ShowCardLine} data={item} city_uid={this.props?.city_uid} city={this.props?.city_name} country={this.props?.country_name} />
                <CardLine 
                    data={item} 
                    ToggleDealDetails={this.handleToggleDealDetails}  
                    open={this.state?.open} slug={item.code} 
                    key={'cardline'+this.props?.index} 
                    counter={(this.props.counter)} 
                    total={this.total} 
                    type={this.props.type} 
                    stars={this.props.stars} 
                    show={this.props.show} 
                    city_name={this.props?.city_name} 
                    country_name={this.props?.country_name}  
                    month={this.props.month} 
                    adults={this.props?.adults} 
                    teens={this.props?.teens}
                    children={this.props?.children} 
                    infants={this.props?.infants} 
                    dow={this.props?.dow} />
                {more}
            </div>
        )

        return html;

    }
}
export default Card